import { ItemCategory } from "./enum/enum";

export const BODYGUARD_INFO = {
  [ItemCategory.BODYGUARD_JOHNNY]: {
    name: "Johnny",
    basePrice: 250000,
    traningPerPrice: 50000,
    img: "johnny-bgsmall.png",
    defensePerLevel: 3,
    offensePerLevel: 4,
  },
  [ItemCategory.BODYGUARD_JIM]: {
    name: "Jim",
    basePrice: 500000,
    traningPerPrice: 110000,
    img: "jim-bgsmall.png",
    defensePerLevel: 6,
    offensePerLevel: 6,
  },
  [ItemCategory.BODYGUARD_SAM]: {
    name: "Sam",
    basePrice: 1000000,
    traningPerPrice: 250000,
    img: "sam-bgsmall.png",
    defensePerLevel: 17,
    offensePerLevel: 7,
  },
  [ItemCategory.BODYGUARD_FRANK]: {
    name: "Frank",
    basePrice: 1300000,
    traningPerPrice: 375000,
    img: "frank-bgsmall.png",
    defensePerLevel: 10,
    offensePerLevel: 25,
  },
};
